var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-back,.b-back{fill:none;}.b-back{stroke:#909090;}.c-back{stroke:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a-back",
    d: "M0,0H16V16H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.556 -177.82) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b-back",
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 189.393, 71)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c-back",
    width: 1.266,
    height: 6.485,
    rx: 0.633
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a-back",
    x: 0.5,
    y: 0.5,
    width: 0.266,
    height: 5.485,
    rx: 0.133
  })), /*#__PURE__*/React.createElement("g", {
    className: "b-back",
    transform: "matrix(-0.719, 0.695, -0.695, -0.719, 186.303, 75.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c-back",
    width: 1.147,
    height: 6.705,
    rx: 0.573
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a-back",
    x: 0.5,
    y: 0.5,
    width: 0.147,
    height: 5.705,
    rx: 0.073
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.659b828f13274db265e09527211ce231.svg";
export { ForwardRef as ReactComponent };